import JobNotes from './JobNotes.container';

export default JobNotes;
